// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropTypes from 'prop-types';

class Checkbox extends Component {
  render() {
    const {
      customClasses,
      name,
      checked,
      imageUrl,
      labelText,
      labelSmall,
      handleChange
    } = this.props;

    return (
      <label className={`filter-v2__checkbox ${customClasses}`}>
        <input
          name={name}
          value={name}
          type="checkbox"
          onChange={handleChange}
          checked={checked}
        />
        <div className="filter-v2__checkbox-label" data-small={labelSmall}>
          { imageUrl && (
            <img
              src={imageUrl}
              className="filter-v2__checkbox-image"
              loading="lazy"
            />
          )}

          { labelText && (
            <p className="filter-v2__checkbox-label-text">
              {labelText}
            </p>
          )}
        </div>
      </label>
    );
  }
}

Checkbox.defaultProps = {
  customClasses: '',
  name: '',
  imageUrl: '',
  labelText: '',
  checked: false,
  labelSmall: false,
  handleChange: () => {},
};

Checkbox.propTypes = {
  customClasses: PropTypes.string,
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  labelText: PropTypes.string,
  checked: PropTypes.bool,
  labelSmall: PropTypes.bool,
  handleChange: PropTypes.func,
};

export default Checkbox;
